import { Component, inject } from '@angular/core';
import { ChatService } from '../../../services/chat/chat.service';

@Component({
  selector: 'app-clear-chat-modal',
  standalone: true,
  templateUrl: './clear-chat-modal.html',
  styleUrl: './clear-chat-modal.scss',
})
export class ClearChatModal {
  private chatService = inject(ChatService);

  clearChat() {
    this.chatService.clearMessages();
  }
}
